import { BsCaretLeftFill, BsCaretRightFill } from "react-icons/bs";
import { collapsedStates } from "./DedicatedDispatchConstants";
export const CollapseButton = ({ collapsedState, setCollapsedState }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        marginLeft: "-.4rem",
        marginRight: "-.4rem",
        zIndex: 1, //we want to keep this over the stops list on the right (to keep pointer events enabled) but below the drag overlay elements
      }}
    >
      <div
        style={{
          position: "relative",
        }}
      >
        {/* This absolute positioned container is so the button doesn't actually take up space and can overlap the things next to it */}
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "grid",
            placeContent: "center",
          }}
        >
          <div
            className="border"
            style={{
              borderRadius: "1000px",
              width: "50px",
              height: "50px",
              display: "flex",
              backgroundColor: "white",
            }}
            // onClick={() => {
            //   setCollapsedState((prev) => {
            //     const collapsedStatesValues = Object.values(
            //       collapsedStates
            //     ).map((state) => state.value);
            //     const lastStateIndex = collapsedStatesValues.findIndex(
            //       (el) => el === prev
            //     );
            //     return lastStateIndex === collapsedStatesValues.length - 1
            //       ? collapsedStatesValues[0]
            //       : collapsedStatesValues[lastStateIndex + 1];
            //   });
            // }}
          >
            <div
              className="inbetween-collapser-icon-container"
              style={{
                position: "absolute",
                inset: 0,
                display: "grid",
                placeContent: "center",
              }}
            >
              {collapsedStates[collapsedState].icon}
            </div>
            <div
              role="button"
              className="inbetween-collapser-button"
              style={{
                // backgroundColor: "red",
                flex: 1,
                borderRadius: "10000px 0px 0px 10000px",
                position: "relative",
              }}
              onClick={() => {
                setCollapsedState((prev) => {
                  const collapsedStatesValues = Object.values(
                    collapsedStates
                  ).map((state) => state.value);
                  const lastStateIndex = collapsedStatesValues.findIndex(
                    (el) => el === prev
                  );
                  if (lastStateIndex > 0) {
                    return collapsedStatesValues[lastStateIndex - 1];
                  } else {
                    return prev;
                  }
                });
              }}
            >
              <div className="inbetween-collapser-button-arrow-container inbetween-collapser-button-arrow-container-left">
                <BsCaretLeftFill className="inbetween-collapser-button-arrow " />
              </div>
            </div>
            <div
              role="button"
              className="inbetween-collapser-button"
              style={{
                // backgroundColor: "blue",
                flex: 1,
                borderRadius: "0px 10000px 10000px 0px",
                position: "relative",
              }}
              onClick={() => {
                setCollapsedState((prev) => {
                  const collapsedStatesValues = Object.values(
                    collapsedStates
                  ).map((state) => state.value);
                  const lastStateIndex = collapsedStatesValues.findIndex(
                    (el) => el === prev
                  );
                  console.log("collapse", lastStateIndex);
                  //   console.log("collapse", collapsedStatesValues.length);
                  if (lastStateIndex < collapsedStatesValues.length - 1) {
                    return collapsedStatesValues[lastStateIndex + 1];
                  } else {
                    return prev;
                  }
                });
              }}
            >
              <div className="inbetween-collapser-button-arrow-container inbetween-collapser-button-arrow-container-right">
                <BsCaretRightFill className="inbetween-collapser-button-arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
